import { apiSlice } from "@/shared/api/api-slice"
import type { BusinessConnection } from "@/shared/types/api/business-mode.types"

export const updateTranscriptionApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessConnection"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      updateTranscription: builder.mutation<BusinessConnection, { autoTranscribeEnabled: boolean }>({
        query: ({ autoTranscribeEnabled }) => ({
          url: `/api/v1/business/connections/transcription`,
          method: "PATCH",
          body: { auto_transcribe_enabled: autoTranscribeEnabled }
        }),
        invalidatesTags: () => [{ type: "BusinessConnection" as const }]
      })
    })
  })

export const { useUpdateTranscriptionMutation } = updateTranscriptionApi
